import * as types from '../types/billingTypes';
import * as billingServices from '../../services/billingServices';

export function fetchPlan() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_PLAN_REQUEST });
    try {
      const data = await billingServices.getPlan();
      dispatch({ type: types.FETCH_PLAN_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_PLAN_FAILURE, payload: error.message });
    }
  };
}

export function fetchPlans() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_PLANS_REQUEST });
    try {
      const data = await billingServices.listPlans();
      const list = Array.isArray(data) ? data : (data.plans || data || []);
      dispatch({ type: types.FETCH_PLANS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_PLANS_FAILURE, payload: error.message });
    }
  };
}

export function fetchHistory() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_HISTORY_REQUEST });
    try {
      const data = await billingServices.getHistory();
      const list = Array.isArray(data) ? data : (data.history || data || []);
      dispatch({ type: types.FETCH_HISTORY_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_HISTORY_FAILURE, payload: error.message });
    }
  };
}

